var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { UploadQueueEntry, validateFileType } from '@square/dashboard-items-data/utils/image-upload';
import { allSettled } from 'rsvp';
const ParallelUploadLimit = 10;

/**
 * This service is used to manage image uploads to the items service to make sure we are not overloading the
 * server.
 *
 * When images are passed to this server for upload we create a `UploadQueueEntry` object for each image, and immediately return them
 * to the application code so they can be displayed to show upload progress as the images are uploaded. These objects have a url that
 * can be used to display a local version of the image, and expose a promise that can be used to react to the async image uploads
 * completing.
 *
 * This service will manage automatically starting the uploads of a reasonable number of images at any given time, and the `UploadQueueEntry`
 * objects automatically handle retrying in the event of a rate limit response from the server.
 */
let ImageUpload = (_class = class ImageUpload extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "uploadQueue", _descriptor2, this);
    _initializerDefineProperty(this, "invalidFiles", _descriptor3, this);
  }
  get hasActiveUploads() {
    return this.uploadQueue.length > 0;
  }
  resetInvalidFiles() {
    this.invalidFiles = [];
  }
  setInvalidFiles(images) {
    this.invalidFiles = images;
  }
  uploadImages(imageFiles) {
    const uploadQueueEntries = imageFiles.map(imageFile => {
      return new UploadQueueEntry({
        imageFile,
        store: this.store
      });
    });
    this.uploadQueue = [...this.uploadQueue, ...uploadQueueEntries];
    this._startUploads();
    return uploadQueueEntries;
  }
  uploadImagesFromFileInput(event) {
    // The `e.files` fallback is only here for testing, as `target` is readonly
    // checking event.originalEvent for the file is necessary for events triggered by jQuery
    let files;
    if (event.target?.files?.length > 0) {
      files = event.target.files;
    } else if (event.originalEvent?.files?.length > 0) {
      files = event.originalEvent.files;
    } else {
      files = event.files;
    }
    if (files) {
      const filesArray = [...files];
      const validFiles = filesArray.filter(file => validateFileType(file));
      this.invalidFiles.push(...filesArray.filter(file => !validateFileType(file)));
      return this.uploadImages(validFiles);
    }
    return [];
  }
  async uploadSuggestedImages(images) {
    const suggestedImages = images;
    const imageFetchPromises = await allSettled(suggestedImages.map(async image => {
      const res = await this.fetchImage(image.suggestedImageUrl);
      if (res?.ok) {
        const imageBlob = await res.blob();
        return imageBlob;
      } else {
        this.invalidFiles.push(image);
        return null;
      }
    }));
    const validImageFiles = [];
    imageFetchPromises.forEach(result => {
      if (result?.state === 'fulfilled' && result?.value instanceof Blob) {
        validImageFiles.push(result.value);
      }
    });
    const uploadedImages = await this.uploadImages(validImageFiles);
    return uploadedImages;
  }
  fetchImage(imageUrl) {
    return fetch(imageUrl, {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    });
  }
  _startUploads() {
    this.uploadQueue.slice(0, ParallelUploadLimit).forEach(uploadQueueEntry => {
      if (!uploadQueueEntry.isUploading) {
        uploadQueueEntry.startUpload();
        uploadQueueEntry.promise.finally(() => {
          this.uploadQueue = this.uploadQueue.filter(upload => {
            return upload.upload_id !== uploadQueueEntry.upload_id;
          });
          this._startUploads();
        });
      }
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "uploadQueue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "invalidFiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class);
export { ImageUpload as default };